var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24923_9739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#AAAAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13752 2.65566C8.13731 2.45999 8.37486 2.36445 8.51252 2.50624L10.491 4.52382C10.5767 4.61205 10.5744 4.74871 10.4862 4.83437L8.46857 6.48671C8.32688 6.62428 8.09202 6.52175 8.09455 6.32949L8.1092 5.03945C7.81688 5.02174 7.52202 5.03912 7.23322 5.09316C6.21309 5.28922 5.33277 5.94149 4.83186 6.82949C4.22553 7.92344 4.24472 9.27509 4.89924 10.3519C4.91515 10.3787 4.92729 10.4074 4.93732 10.4359C5.58916 11.4548 6.7544 12.1209 8.08478 12.0551C9.37513 11.9911 10.5175 11.1646 11.077 9.99746C11.3859 9.34683 11.4563 8.72477 11.3846 8.1371C11.3644 7.99573 11.4153 7.84886 11.5203 7.75234C11.7854 7.51316 12.2136 7.66749 12.2557 8.02089C12.3318 8.60869 12.2877 9.23107 12.0848 9.86855C11.5567 11.5382 10.0455 12.7712 8.29865 12.9213C5.33828 13.178 2.97934 10.5366 3.60529 7.59609C3.73063 7.00917 3.97876 6.46622 4.31818 5.99257C4.34773 5.95097 4.37882 5.9103 4.40998 5.86953C4.43744 5.83391 4.46545 5.7988 4.49396 5.76406C4.60161 5.63186 4.71731 5.50386 4.8426 5.38222C5.75321 4.49815 6.94884 4.09679 8.12189 4.15761L8.13752 2.65566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24923_9739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIconGray);
export default __webpack_public_path__ + "static/media/publish-icon-gray.17ad5b00.svg";
export { ForwardRef as ReactComponent };